var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('topbar'),(_vm.$root.showNav)?_c('mainnav'):_vm._e(),_c('vue-page-transition',{staticStyle:{"width":"100%"},attrs:{"name":"fade"}},[_c('router-view')],1),_c('locale-changer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }